import { render, staticRenderFns } from "./BrokenLinkNotifications.vue?vue&type=template&id=7ccf89e7&scoped=true"
import script from "./BrokenLinkNotifications.vue?vue&type=script&lang=js"
export * from "./BrokenLinkNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf89e7",
  null
  
)

export default component.exports